import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import i18n from 'i18next';

import { NVISION_USER_TYPES } from '@/contants/common';

import FormSelectBox from '../../../../components/Inputs/FormSelectBox';
import { useGetShipmentBranchList } from '../../hooks';

export const ShipmentBranchSelect = ({
  placeholder = i18n.t('translation:default.fields.shipmentBranch.placeholder'),
  label = i18n.t('translation:default.fields.shipmentBranch.label'),
  rules = [],
  name,
  editMode,
  margin,
  id = '',
  customerId,
  userType,
  tooltip = false,
  mode = '',
  disableValidation = false,
  onChange = () => {},
  labelWithValue = false,
  tabIndex,
}) => {
  const { selectedCompany } = useSelector((state) => state.auth);

  const { data = [], isLoading } = useGetShipmentBranchList({
    Customerkey: userType === NVISION_USER_TYPES.CUST ? selectedCompany.companyId : customerId,
  });

  const options = useMemo(
    () =>
      data.map((row) => ({
        label: row.branchDesc,
        value: row.branchKey,
      })),
    [data],
  );

  return (
    <FormSelectBox
      loading={isLoading}
      options={options}
      placeholder={placeholder}
      label={label}
      rules={rules}
      name={name}
      editMode={editMode}
      margin={margin}
      id={id}
      tooltip={tooltip}
      mode={mode}
      disableValidation={disableValidation}
      onChange={onChange}
      labelWithValue={labelWithValue}
      tabIndex={tabIndex}
    />
  );
};
